import axiosClient from './axios-client';
import type { PaginationParams } from './common.dto';
import { API_ENDPOINTS } from '@/constants';

export interface Salesperson {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  country?: string;
  state?: string;
  address?: string;
  zipCode?: string;
  city?: string;
  company?: string;
  status: SalespersonStatus;
  isSalesperson: boolean;
  userRole: string;
  isRecommended?: boolean;
  createdAt: string;
  updatedAt: string;
}

export type SalespersonStatus = 'active' | 'inactive' | 'suspended';

export interface SalespersonParams extends PaginationParams {
  search?: string;
  status?: SalespersonStatus;
  isSalesperson?: boolean;
  orderId?: string;
}

export interface CreateSalespersonRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  phone?: string;
  country?: string;
  state?: string;
  address?: string;
  zipCode?: string;
  city?: string;
  company?: string;
  status?: SalespersonStatus;
  isSalesperson?: boolean;
  userRole?: string;
}

export interface UpdateSalespersonRequest {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  country?: string;
  state?: string;
  address?: string;
  zipCode?: string;
  city?: string;
  company?: string;
  status?: SalespersonStatus;
  userRole?: string;
}

export const salespersonsApi = {
  getAll: async (params?: SalespersonParams): Promise<Salesperson[]> => {
    const response = await axiosClient.get(API_ENDPOINTS.SALESPERSONS, { params });
    return response.data;
  },

  getById: async (id: string): Promise<Salesperson> => {
    const response = await axiosClient.get(API_ENDPOINTS.SALESPERSONS_BY_ID(id));
    return response.data;
  },

  create: async (data: CreateSalespersonRequest): Promise<Salesperson> => {
    const response = await axiosClient.post(API_ENDPOINTS.SALESPERSONS, data);
    return response.data;
  },

  update: async (id: string, data: UpdateSalespersonRequest): Promise<Salesperson> => {
    const response = await axiosClient.patch(API_ENDPOINTS.SALESPERSONS_BY_ID(id), data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await axiosClient.delete(API_ENDPOINTS.SALESPERSONS_BY_ID(id));
  },
};
